<template>
  <PageHomepage
    :featured-articles="featuredArticles"
    :block-homepage-content="blockHomepageContent"
    :featured-banners="featuredBanners ? featuredBanners : []"
    :featured-products="{mostSoldProducts, newestProducts, saledProducts}"
    :info-boxes="infoBoxes"/>
</template>

<script>
import Component from '~/sites/shop/pages/index'
export default {
  extends: Component,
  async asyncData({ app, store, res }) {
    if (process.server) {
      res.set('X-Inspishop-Cache-Control', `public, max-age=${app.$env.STATELESS_TTL}`)
    }

    store.commit('locale/SET_CANONICALS')

    const data = {
      blockHomepageContent: app.$themeSettings.components.PageHomepage.showHomepageTextBlock
        ? store.dispatch('homepage/LOAD_HOMEPAGE_CONFIGURATION')
        : null,
      featuredBanners: app.$themeSettings.components.PageHomepage.showSlider
        ? store.dispatch('banner/LOAD_HOMEPAGE_BANNERS')
        : null,
      mostSoldProducts: app.$themeSettings.components.PageHomepage.mostSoldProducts.enable
        ? store.dispatch('product/LOAD_FEATURED_PRODUCTS', { type: 'most_sold' })
        : null,
      newestProducts: app.$themeSettings.components.PageHomepage.newestProducts.enable
        ? store.dispatch('product/LOAD_FEATURED_PRODUCTS', { type: 'newest' })
        : null,
      saledProducts: app.$themeSettings.components.PageHomepage.saledProducts.enable
        ? store.dispatch('product/LOAD_FEATURED_PRODUCTS', { type: 'sale' })
        : null,
      articles: app.$themeSettings.components.PageHomepage.featuredArticles.enable
        ? store.dispatch('article/LOAD_ARTICLES', {
            page: 0,
            perPage: app.$themeSettings.components.PageHomepage.featuredArticles.count,
          })
        : [],
      infoBoxes: app.$contentSettings.infoBoxes ? store.dispatch('banner/LOAD_INFO_BOXES') : null,
    }

    let result = await Promise.allValues(data, [store.dispatch('category/FETCH_TOP_CATEGORIES')])
    if (app.$contentSettings.functions.ssrPropertyPicker && process.server) {
      const mixin = (await import('~/mixins/SSRPropertyPickMixin.vue')).default

      result = mixin.methods.pickKeysFromPayload({
        payload: result,
        rules: mixin.computed.ssrPayloadRules(),
        pickers: mixin.computed.ssrPayloadPickers(),
      })
    }

    await app.apolloProvider.defaultClient.cache.reset()
    return result
  },
}
</script>
